import { inject, Injectable } from '@angular/core';
import { catchError, EMPTY, Observable } from 'rxjs';

import { CounselUsersByType } from 'src/app/swagger-api';
import { DefaultService as RestApiService } from 'src/app/swagger-api/api/default.service';

@Injectable()
export class GlobalCounselService {
  private apiService = inject(RestApiService);

  public getGSECUserList(): Observable<CounselUsersByType> {
    return this.apiService.restUserGetCounsel().pipe(catchError(() => EMPTY));
  }
}
